export const getDirectionalVariationColors = (variation: string) => {
  switch (variation) {
    case 'primary':
      return {
        circleColor: '#2b4fb9',
        pathColor: '#fff',
        circleColorHover: '#002182',
        pathColorHover: '#fff',
        backgroundColor: '#2b4fb9',
        backgroundColorHover: '#002182',
        disabled: {
          circleColor: '#E7EAF6',
          pathColor: '#fff',
          circleColorHover: '#E7EAF6',
          pathColorHover: '#fff',
          backgroundColor: '#E7EAF6',
          backgroundColorHover: '#E7EAF6'
        }
      }
    case 'secondary':
      return {
        circleColor: '#2b4fb9',
        pathColor: '#2b4fb9',
        circleColorHover: '#002182',
        pathColorHover: '#002182',
        backgroundColor: '#fff',
        backgroundColorHover: '#fff',
        disabled: {
          circleColor: '#2b4fb9',
          pathColor: '#2b4fb9',
          circleColorHover: '#002182',
          pathColorHover: '#002182',
          backgroundColor: '#fff',
          backgroundColorHover: '#fff'
        }
      }
    case 'elevated':
    case 'quiet':
      return {
        circleColor: '#fff',
        pathColor: '#2b4fb9',
        circleColorHover: '#fff',
        pathColorHover: '#002182',
        backgroundColor: '#fff',
        backgroundColorHover: '#fff'
      }
    case 'dark':
      return {
        circleColor: '#474747',
        pathColor: '#fff',
        circleColorHover: '#474747',
        pathColorHover: '#fff',
        backgroundColor: '#474747',
        backgroundColorHover: '#474747'
      }
    default:
      return {
        circleColor: '#2b4fb9',
        pathColor: '#fff',
        circleColorHover: '#002182',
        pathColorHover: '#fff',
        backgroundColor: '#2b4fb9',
        backgroundColorHover: '#002182'
      }
  }
}
